import axios from 'axios'
import { cookies } from '@zing/shared/cookies/behavior'
import { showToast } from '@zing/shared/components/toast'
import { store } from '@zing/shared/store'
import { logout } from '@zing/shared/auth'
import { API_BASE_URL } from '@zing/shared/constants'

export const api = axios.create({
  baseURL: API_BASE_URL 
})

api.interceptors.request.use(
   async (config) => {
      if (!config.headers) {
        config.headers = {};
      }
      if (config.headers.Authorization) {
        return config;
      }
 
   const cookieData = cookies.get('_cred');
   const sessionToken = sessionStorage.getItem('jwt');
   const headerToken = cookieData?.data?.token || sessionToken;
   
   if (headerToken) {
        const token = `Bearer ${headerToken}`;
        config.headers.Authorization = token;
   }
   config.headers['Content-Type'] = 'application/json';
   config.headers['Current-Language'] = localStorage.getItem('language') ?? 'pt-BR';
 
   return config;
   },
   async (error) => {
    return Promise.reject(error);
   }
  );
api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error?.response == null) {
      return Promise.reject(error)
    }
    const responseData = error.response.data
    const hasMessage =
      responseData != null &&
      typeof responseData === 'object' &&
      !Array.isArray(responseData) &&
      Object.prototype.hasOwnProperty.call(responseData, 'message')
    if (hasMessage) {
      const errorMessage = (responseData as { message?: unknown }).message
      const status = error.response.status
      if (status === 400 || (status >= 402 && status <= 451)) {
        showToast('error', `${String(errorMessage)}`)
      } else if (status === 401) {
        if (cookies.get('_cred') != null) {
          store.dispatch(logout())
          showToast('error', 'Por motivos de segurança você foi deslogado! Efetue o login e tente novamente')
        } else {
          showToast('error', responseData.errorMessage)
        }
      }
    }

    return Promise.reject(error)
  }
)